import React from "react";
import classNames from "classnames";
import "./PageSideBar.scss";

const PageSideBar = (props) => {
  let mainClassName = classNames({
    "page-sidebar": true,
    "page-sidebar-expanded": !!props.expanded,
    "page-sidebar-collapsed": !props.expanded,
  });
  return <div className={mainClassName}>{props.children}</div>;
};

export default PageSideBar;
